<template>
    <div class="carban-out">
        <div class="search_wrap">
            <el-form
                class="leader-style-form leader-form-inner-tab-inline"
                :inline="true"
                :model="searchForm"
            >
                <el-form-item label="时间" style="float: left">
                    <el-date-picker
                        v-model="searchForm.time"
                        type="month"
                        placeholder="选择日期"
                        value-format="yyyy-MM"
                        format="yyyy-MM"
                        :picker-options="pickerOptions"
                        :clearable="false"
                        :editable="false"
                    ></el-date-picker>
                    <el-button
                        type="primary"
                        size="small"
                        style="margin-left: 40px"
                        >查询</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
        <div class="carban-out-container">
            <div class="carban-out-echarts">
                <v-chart
                    :auto-resize="true"
                    :options="carbanOutBar"
                    ref="carbanOutBar"
                    theme="ovilia-green"
                />
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/treemap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import * as api from "@/http/api.js";
export default {
    data() {
        return {
            searchForm: {
                time: ""
            }
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.time = res.bus_json.sysdate3;
                }
            });
        }
    },
    computed: {
        carbanOutBar() {
            const option = {
                title: {
                    text: "",
                    left: "50%",
                    textStyle: {
                        color: "#fff"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function(params) {
                        var tar = params[0];
                        // return "综合能耗:"+tar.data.value+"元";
                        return (
                            tar.axisValue +
                            "<br/>" +
                            "碳排放：" +
                            tar.data +
                            "吨"
                        );
                    }
                },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "3%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        axisLabel: {
                            fontSize: 14,
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff"
                            }
                        },
                        xAxisLeft: "#666",

                        data: [
                            "2022-02",
                            "2022-03",
                            "2022-04",
                            "2022-05",
                            "2022-06",
                            "2022-07",
                            "2022-08",
                            "2022-09",
                            "2022-10",
                            "2022-11",
                            "2022-12",
                            "2023-01"
                        ]
                    }
                ],
                yAxis: [
                    {
                        name: "吨",
                        type: "value",
                        yAxisTop: "yellow",
                        nameTextStyle: {
                            color: "white",
                            padding: 10,
                            fontSize: 14
                        },
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff" //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff"
                            }
                        },
                        xAxisLeft: "#666666"
                    }
                ],
                series: [
                    {
                        name: "碳排放",
                        type: "bar",
                        itemStyle: {
                            normal: {
                                color: "#64c1f0" // 柱子颜色
                            }
                        },
                        barWidth: "30%",
                        data: [50, 55, 57, 60, 65, 63, 62, 60, 54, 58, 56, 57]
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.carban-out {
    padding: 0 20px 10px 20px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    .carban-out-container {
        width: 100%;
        height: 30rem;
        color: #fff;
        background-size: 100% 100%;

        .carban-out-echarts {
            width: 100%;
            height: 100%;
            clear: both;

            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
